// EditHistoryButton - 画面右側の独立トグルボタン（spec.md §5.8.4）
// PublishStepsPanel の下に常駐し、タップで EditHistoryModal を開く。

import { useState } from "react";
import { useSelector } from "react-redux";
import HistoryIcon from "@mui/icons-material/History";
import { RootState } from "app/store";
import I18n from "common/i18n";
import { useScale, usePlaySound, btnDelay } from "common/utils";
import { EditHistoryModal } from "./EditHistoryModal";

const HISTORY_BTN_BASE_HEIGHT = 48;
const HISTORY_BTN_BASE_WIDTH = 220;

export const EditHistoryButton = () => {
  const play = usePlaySound();
  const { scale } = useScale();
  const editHistory = useSelector((state: RootState) => state.builder.editHistory);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    play();
    btnDelay(() => setOpen(true));
  };

  return (
    <>
      <div className="flex-col-el absolute bottom-3 right-0 z-[10001] pointer-events-none">
        <div
          className="pointer-events-auto"
          style={{
            width: HISTORY_BTN_BASE_WIDTH * scale,
            height: HISTORY_BTN_BASE_HEIGHT * scale,
            marginRight: 8 * scale,
          }}
        >
          <div
            className="flex-col-el origin-top-left"
            style={{
              width: HISTORY_BTN_BASE_WIDTH,
              height: HISTORY_BTN_BASE_HEIGHT,
              transform: `scale(${scale})`,
            }}
          >
            <button
              onClick={handleOpen}
              aria-label={I18n.t("MSG_BUILDER_EDIT_HISTORY")}
              className="flex-row-el flex-center gap-2 h-12 px-4 rounded-full bg-white border-2 border-amber-200 active:scale-95 transition-colors type-inherit-font whitespace-nowrap"
            >
              <span className="flex-col-el flex-center type-title text-amber-500">
                <HistoryIcon fontSize="inherit" />
              </span>
              <span className="type-sm text-textcolor-black whitespace-nowrap">
                {I18n.t("MSG_BUILDER_EDIT_HISTORY")}
              </span>
              {editHistory.length > 0 && (
                <span className="flex-col-el flex-center rounded-full bg-amber-500 px-2 type-sm text-white whitespace-nowrap">
                  {editHistory.length}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>

      <EditHistoryModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};
